export const BOLD_GROUP = {
  SET_REPAIR_LIST: "BOLD_GROUP_SET_REPAIR_LIST",
  SET_REPAIR_DETAIL: "BOLD_GROUP_SET_REPAIR_DETAIL",
  SET_REPAIR_JOB_DETAIL: "BOLD_GROUP_SET_REPAIR_JOB_DETAIL",
  CLEAR_REPAIR_DETAIL: "BOLD_GROUP_CLEAR_REPAIR_DETAIL",
  CLEAR_REPAIR_POINT: "BOLD_GROUP_CLEAR_REPAIR_POINT",
  SET_CENTER_MAP: "BOLD_GROUP_SET_CENTER_MAP",
  SET_COVERAGE: "BOLD_GROUP_SET_COVERAGE",
  SET_COVERAGE_ROUTE: "BOLD_GROUP_SET_COVERAGE_ROUTE",
  SET_ACCESSORY_ODF_MDF: "BOLD_GROUP_SET_ACCESSORY_ODF_MDF",
};
